<template>
  <h1>Item Information</h1>
  <div class="item_titel">{{ item.title }}</div>
  <div class="discription"><div class="discription">{{ item.content }}</div></div>
  <div v-if="item.category === 'オープンデータ'">
    <button type="submit" @click="setTarget(item.title), download()">
        Download Opendata
    </button>
    <a id="downloadAnchorElem" style="display: none"></a>
    <button
      type="button"
      :class="item.title"
      :id="item.title"
      @click="
        setTarget(item.title);
        downloadPreview($event);
      "
    >
      Preview
    </button>
    <div v-if="preView[0] === item.title" class="content">
      {{ preView[1] }}
    </div>
  </div>

  <div class="table_box">
    <div class="meta_data">コンテンツ名</div><div class="meta_data">{{ item.title }}</div>
    <div class="meta_data">カテゴリ</div><div class="meta_data">{{ item.category }}</div>
    <div class="meta_data">タグ</div><div class="meta_data">{{ item.filegenre }}</div>
  </div>
  <div v-if="item.manager || item.manager === '未設定'">
    <div class="table_box">
      <div class="meta_data">管理者</div><div class="meta_data">{{ item.manager }}</div>
    </div>
  </div>
  <div v-else>
    <div class="table_box">
      <div class="meta_data">公開ユーザー</div><div class="meta_data">{{ item.user }}</div>
    </div>
  </div>
  <div class="table_box">
    <div class="meta_data">更新日</div><div class="meta_data">{{ item.updateAt }}</div>
  </div>
  <div v-if="item.category === 'オープンデータ'">
    <div class="table_box">
      <div class="meta_data">ライセンス</div><div class="meta_data">{{ item.license }}</div>
    </div>
    <div>データの構造や単位の説明</div><br />
    <div class="description">{{ item.description }}</div>
  </div>
  <div v-if="item.category === 'API'">
    <section>
      <h3>API基本情報</h3>
      ベースURL:{{ baseURL }}<br />
    </section>
    <section>
      <h3>APIエンドポイント一覧</h3>
    </section>
    <section v-for="endpoint in item.endpoint" :key="endpoint._id">
      エンドポイント名:{{ endpoint.name }}<br />
      メソッド:{{ endpoint.method }}<br />
      パス:/{{ item._id }}/{{ endpoint.name }}<br />
      <h4>説明</h4><br /><div class="description">{{ endpoint.description }}</div>
    </section>
    <div style="text-align: right;">
      API利用方法は<router-link to="/apitutorial">こちら</router-link>をご参照ください。<br />
    </div>
  </div>
</template>

<script setup>
// カタログリストで選択されたアイテムの詳細情報を表示するコンポーネント
// paramsでアイテムIDを受け取り、そのIDに基づいて詳細情報を取得・表示する
import { useRoute } from "vue-router";
import { useUserStore } from "../store/user.js";
import { ref, computed, onMounted } from "vue";
const route = useRoute();
const userStore = useUserStore();
const itemId = route.params.Id;
const item = ref([]);
const preView = ref("");
const baseURL = ref("");
computed(() => {
  return item.value
});
async function setTarget(target) {
  console.log(target);
  //opendataTarget = target;
  userStore.setOpendataTarget(target);
}

async function getOpendata() {
  await userStore.getOpendataList();
  item.value = userStore.opendataList.find(
    (item) => item.title === itemId
  );
  item.value.updateAt = new Date(item.value.updateAt).toLocaleDateString();
  console.log(item.value);
}

async function downloadPreview(event) {
  console.log(event.currentTarget);
  const id = event.currentTarget.id;
  try {
    const res = await userStore.downloadPreview();
    preView.value = [id, res];
  } catch (error) {
    console.error(error);
  }
}

async function download() {
  try {
    const res = await userStore.download();
    const jsonString = JSON.stringify(res);
    // userStore.opendataTargetResult = res;
    DownloadJson(jsonString);
  } catch (error) {
    console.error(error);
  }
}

function DownloadJson(opendata) {
  var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(opendata);
  var dlAnchorElem = document.getElementById("downloadAnchorElem");
  dlAnchorElem.setAttribute("href", dataStr);
  dlAnchorElem.setAttribute("download", `${userStore.opendataTarget}.json`);
  dlAnchorElem.click();
}
async function getbaseURL() {
  try{
    baseURL.value = await userStore.getbaseURL();
  } catch (error) {
    console.error(error);
  }
}

onMounted(() => {
  getbaseURL();
  getOpendata();
});
</script>

<style>
.item_titel {
  font-size: 48px;
  margin-left: 3rem;
  text-decoration: underline;
  text-underline-position: auto;
}
.description {
  margin: 0 1rem 1rem 1rem;
  white-space: pre-line;
}
.table_box {
  margin-top: 0;
  border: 1px solid #ccc;
  display: grid;
  grid-template-columns: 200px 1fr;
  padding: 0;
  width: 50%;
}

.table_box .meta_data {
  margin: 0;
  border: 1px solid #ccc;
}

.content {
  height: 200px;
  overflow-y: auto;
  border: 1px solid #ccc;
  padding: 10px;
}
</style>